export function getFromJSON(_text, _value_for_error) {
  try {
    const _val = JSON.parse(_text)
    return _val
  } catch (e) {
    return _value_for_error
  }
}
export function getIndex(_array, _value) {
  var _index = 0  
  for(let i = 0; i<_array.length; i++) {
    if (Math.abs(_array[i]-_value) < Math.abs(_array[_index] - _value))   
      _index = i
  }
  return _index
}
export function unSpan(txt) {
  var data = txt
  var start = 0
  var end = 0
  while (data.indexOf('<span') > -1) {
      start = data.indexOf('<span')
      end = data.indexOf('>',start)
      data = data.substring(0,start) + data.substring(end+1)
      start = data.indexOf('</span>')
      data = data.substring(0,start) + data.substring(start+7)
  }
  return data
}
export function makeNice(a) {
  while (a.indexOf('&lt;')>-1) a = a.replace('&lt;','<')
  while (a.indexOf('&gt;')>-1) a = a.replace('&gt;','>')
  while (a.indexOf('&amp;')>-1) a = a.replace('&amp;','&')
  return a
}

export function hardReplace(_text,_old,_new) {
  while (_text.indexOf(_old)> -1) 
    _text = _text.substring(0, _text.indexOf(_old)) + _new + _text.substring(_text.indexOf(_old) + _old.length)            
  return _text
}

export function prepareJupyterTextContent(_arr) {
  var _result = ""
  var _ul = false // for ul/li
  for(let i=0; i<_arr.length; i++) {
      if (_arr[i].substring(0,1) == "-") {                    
          if (_ul) _result +="<li>" + _arr[i].substring(1) + "</li>"
          else _result +="<ul><li>" + _arr[i].substring(1) + "</li>"
          _ul = true
          continue
      }
      if (_ul) {
          _result +="</ul>"
          _ul = false
      }

      if (_arr[i].substring(0,3) == "###") {
          _result +="<h3>" + _arr[i].substring(3) + "</h3>"                    
          continue
      }
      if (_arr[i].substring(0,2) == "##") {
          _result +="<h2>" + _arr[i].substring(2) + "</h2>"
          continue
      }
      if (_arr[i].substring(0,1) == "#") {
          _result +="<h1>" + _arr[i].substring(1) + "</h1>"
          continue
      }
      _result +="<p>" + _arr[i] + "</p>"
  }
  return ""+_result
}

export function deleteHTMLJupyterPart(_arr) {
  const _res = []
  _arr.forEach(element => {
      _res.push( {
          cell_type: element.cell_type,
          execution_count: element.execution_count,
          metadata: element.metadata,
          outputs: element.outputs,
          source: element.source,
          html: ''
      })                
  });
  return _res
}

export function cyrillicToLatin(text) {
  const map = {
      'А': 'A', 'Б': 'B', 'В': 'V', 'Г': 'G', 'Д': 'D', 'Е': 'E', 'Ё': 'Yo',
      'Ж': 'Zh', 'З': 'Z', 'И': 'I', 'Й': 'Y', 'К': 'K', 'Л': 'L', 'М': 'M',
      'Н': 'N', 'О': 'O', 'П': 'P', 'Р': 'R', 'С': 'S', 'Т': 'T', 'У': 'U',
      'Ф': 'F', 'Х': 'Kh', 'Ц': 'Ts', 'Ч': 'Ch', 'Ш': 'Sh', 'Щ': 'Shch',
      'Ъ': '', 'Ы': 'Y', 'Ь': '_', 'Э': 'E', 'Ю': 'Yu', 'Я': 'Ya',
      'а': 'a', 'б': 'b', 'в': 'v', 'г': 'g', 'д': 'd', 'е': 'e', 'ё': 'yo',
      'ж': 'zh', 'з': 'z', 'и': 'i', 'й': 'y', 'к': 'k', 'л': 'l', 'м': 'm',
      'н': 'n', 'о': 'o', 'п': 'p', 'р': 'r', 'с': 's', 'т': 't', 'у': 'u',
      'ф': 'f', 'х': 'kh', 'ц': 'ts', 'ч': 'ch', 'ш': 'sh', 'щ': 'shch',
      'ъ': '_', 'ы': 'y', 'ь': '_', 'э': 'e', 'ю': 'yu', 'я': 'ya'
  };
  // console.log(text.split('').map(char => map[char] || char).join(''))
  return text.split('').map(char => map[char] || char).join('');
}


